/**
 * @file 长图文页
 * @author yanyiting@baidu.com
 */

import app from '@app';
import {Component} from 'san';
import './index.scss';
import ImgText from '@components/img-text';
import AttentionBar from '@components/attention-bar';
import BigTitle from '@components/bigTitle';
// import InvokeAppBar from '@components/invoke-app-bar';
import InvokeAppBrand from '@components/invoke-app-brand';
import CommentCard from '@components/comment-card';
import RecommendCard from '@components/recommend-card';
import TopBar from '@components/top-bar';
import RichText from '@components/rich-text';
import {sendLog} from '@utils/log/index';
import {openAppNaPage} from '@utils/open-app';
import InvokeAppBubble from '@components/invoke-app-bubble';
import InvokeAppBanner from '@components/invoke-app-banner';
import getFr from '@utils/get-fr';
import url from '@utils/url';

const PAGE_PARAMS = url.parse(location.href).params;
const NEW_CHANNEL_NUMBER = PAGE_PARAMS.newCN || '1024444a';
const INVOKE_CHANNEL_NUMBER = PAGE_PARAMS.invokeCN || '1024444b';

export default class AppComponent extends Component {
    constructor(opts) {
        super(opts);
    }
    static template = `
        <div class="wrap">
            <components-top-bar></components-top-bar>
            <div s-if="reflow" on-click="invokeClick('brandInvoke')">
                <components-invoke-app-brand></components-invoke-app-brand>
            </div>
            <div class="card-container common-padding {{hiddenContentClass}}">
                <components-attention-bar
                    class="attention-com"
                    reflow="{{reflow}}"
                    avatar="{{author.avatar}}"
                    name="{{author.nickname}}"
                    brief="{{author.brief}}"
                    on-confirm-click="followBarClick"/>
                <div on-click="invokeClick('hotspot')">
                    <components-big-title
                        class="big-title-com"
                        data="{{titleData}}" />
                    <components-rich-text class="rich-text-wrap" s-if="htmlData" data="{{htmlData}}"/>
                    <components-img-text
                        s-else
                        class="img-text-com"
                        gemFrom="{{gemFrom}}"
                        data="{{contentData}}" />
                </div>
            </div>
            <div class="cover-bar" s-if="reflow && !contentVisible">
                <div class="bar-top"></div>
                <div class="arrow-icon"></div>
                <div class="bar-button" on-click="invokeClick('viewMoreArticle')">打开APP阅读全文</div>
            </div>
            <components-invoke-app-banner
                bannerItem="{{bannerData}}"
                on-banner-click="bannerClick"
                s-if="reflow"/>         
            <components-comment-card
                s-if="reflow"
                class="card-container"
                commentNum="{{commentNum}}"
                commentAvatar="{{commentAvatar}}"
                list="{{commentList}}"
                on-inputclick="invokeClick('comInput')"
                on-likeclick="invokeClick('comLike')"
                on-seereplyclick="invokeClick('comMore')"
                on-seecommentclick="invokeClick('comMore')" />
            <components-recommend-card
                s-if="{{recommendData.length > 0}}"
                class="rec-list-wrap"
                reflow="{{reflow}}"
                list="{{recommendData}}"
                on-moreclick="relateMoreClick"
                on-likeclick="invokeClick('relateLike')"
                on-itemclick="recItemClick" />
            <components-invoke-app-bubble
                s-if="reflow"
                on-go-click="bubbleClick"
                bubbleItem="{{bubbleData}}"/>
            <div class="app-invoke-wrap" s-if="reflow">
                <div class="app-invoke-btn" on-click="invokeClick('fixedInvoke')">APP内阅读</div>
            </div>
        </div>
    `;
    static components = {
        'components-attention-bar': AttentionBar,
        'components-big-title': BigTitle,
        'components-img-text': ImgText,
        'components-comment-card': CommentCard,
        'components-recommend-card': RecommendCard,
        // 'components-invoke-app-bar': InvokeAppBar,
        'components-invoke-app-brand': InvokeAppBrand,
        'components-top-bar': TopBar,
        'components-rich-text': RichText,
        'components-invoke-app-bubble': InvokeAppBubble,
        'components-invoke-app-banner': InvokeAppBanner
    };
    attached() {
        sendLog('pv');
    }
    initData() {
        const {article, comment, rec, recBarList, bubble, banner, isPure} = window.INITIAL_DATA.data;
        const {gemId, gemType, title, content, commentNum, commentAvatar, author, gemFrom, nid, html} = article;

        return {
            isPure,
            gemId,
            gemType,
            author,
            titleData: title,
            bubbleData: bubble,
            bannerData: banner,
            contentData: content,
            commentList: comment,
            recBarList,
            commentNum,
            commentAvatar,
            recommendData: rec,
            gemFrom,
            nid,
            htmlData: html,
            reflow: getFr() !== 'top1' && !isPure,
            invokeModalVisible: false,
            contentVisible: false,
            hasHotspot: PAGE_PARAMS.hasHotspot
        };
    }
    static computed = {
        hiddenContentClass() {
            let reflow = this.data.get('reflow');
            let contentVisible = this.data.get('contentVisible');
            let res = '';
            if (reflow && !contentVisible) {
                res = 'hidden-content';
            }
            return res;
        }
    }

    // 临时注释 components-invoke-app-bar 组件方法

    // <components-invoke-app-bar
    //     s-if="reflow"
    //     barList="{{recBarList}}"
    //     on-go-click="barClick" />

    // barClick({gemId, gemType}) {
    //     this.invokeAppByConfig({
    //         id: gemId,
    //         type: gemType,
    //         useCopy: true
    //     });
    //     sendLog('clk', {
    //         value: 'floatBar'
    //     });
    // }
    bannerClick(data) {
        this.bannerOrBarClick(data, 'banner');
    }
    bannerOrBarClick(data, type) {
        let {jumpType, url, bannerId} = data;
        if (jumpType === 2) {
            window.location.href = url;
        }
        else if (jumpType === 3) {
            let useCopy = type === 'banner';

            this.invokeAppByScheme({
                scheme: url,
                useCopy
            });
        }
        sendLog('clk', {
            value: type,
            ext: {
                'element_id': bannerId
            }
        });
    }
    bubbleClick(data) {
        this.bannerOrBarClick(data, 'bubble');
    }
    invokeAppByScheme(opt) {
        let {scheme, useCopy} = opt;
        openAppNaPage(
            scheme,
            {
                invokeCN: INVOKE_CHANNEL_NUMBER,
                newCN: NEW_CHANNEL_NUMBER,
                wait: 1000,
                useCopy
            }
        );
    }
    invokeAppByConfig(data) {
        let {id, type, useCopy} = data;
        openAppNaPage(
            {
                id,
                type
            },
            {
                wait: 1000,
                useCopy,
                invokeCN: INVOKE_CHANNEL_NUMBER,
                newCN: NEW_CHANNEL_NUMBER
            }
        );
    }
    followBarClick() {
        let author = this.data.get('author');
        let {isAppraiser, buid} = author;
        let type = 9;
        if (isAppraiser) {
            type = 10;
        }
        let data = {
            id: buid,
            type,
            useCopy: true
        };
        this.invokeAppByConfig(data);
        sendLog('clk', {
            value: 'followBar'
        });
    }
    // 回流App
    invokeClick(position) {
        if (position === 'hotspot') {
            if (!this.data.get('hasHotspot')) {
                return;
            }
        }
        sendLog('clk', {
            value: position
        });
        let data = {
            id: this.data.get('gemId'),
            type: this.data.get('gemType'),
            useCopy: true
        };
        this.invokeAppByConfig(data);
        if (position === 'viewMoreArticle') {
            setTimeout(() => {
                this.data.set('contentVisible', true);
            }, 5000);
        }
    }
    relateMoreClick() {
        let data = {
            type: 0
        };
        this.invokeAppByConfig(data);
        sendLog('clk', {
            value: 'relateMore'
        });
    }
    // 点击相关推荐卡
    recItemClick(item) {
        let reflow = this.data.get('reflow');
        if (reflow) {
            let data = {
                id: item.gemId,
                type: item.gemType,
                useCopy: true
            };
            this.invokeAppByConfig(data);
        }
        sendLog('clk', {
            value: 'relateCard'
        });
    }
}
app(AppComponent, '#app');